// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import axios from 'axios'

// Internal Dependencies:
import Text from 'components/Form/Text'
import RadioButtons from 'components/Form/RadioButtons'
import File from 'components/Form/File'
import Record from 'components/Form/Record'

// Redux:
import { updateAccount } from 'actions/site'

class PocketStudio extends React.Component {
	constructor( props ) {
		super( props )

		let sumbitter_name = props.userName || ''
		let church_name = props.userChurchName || ''
		let email = props.userEmail || ''
		let phone = props.userPhone || ''
		phone = phone.toString()

		if ( props.accountData ) {
			sumbitter_name = props.accountData.name
			church_name = props.accountData.church_name
			email = props.accountData.email
			phone = props.accountData.phone
		}

		this.state = {
			isProcessing: false,
			isProcessed: false,
			hasSuccess: false,
			hasError: false,
			errorMessage: '',
			sumbitter_name: sumbitter_name,
			church_name: church_name,
			email: email,
			phone: phone,
			fileUploadType: 'record',
			files: [],
			recordedAudioData: false,
			uploadedFileNames: []
		}
	}

	handleChange = ( id, value ) => {
		const { dispatch } = this.props

		this.setState( {
			[ id ]: value
		} )
	}

	handleSubmit = ( e ) => {
		e.preventDefault()

		const { dispatch } = this.props
		const { sumbitter_name, church_name, email, phone, fileUploadType, files, recordedAudioData } = this.state

		if ( ! sumbitter_name || ! church_name || ! email || ! phone ) {
			this.setState( {
				hasError: true
			} )

			return
		}

		// Get audio file:
		let audio, audioFileName

		if ( 'record' == fileUploadType && recordedAudioData.audioBlob ) {
			audio = recordedAudioData.audioBlob
			audioFileName = `${church_name}-${sumbitter_name}.${recordedAudioData.extension}`
		} else if ( files && files.length ) {
			audio = files[0]
			audioFileName = files[0].name
		}

		if ( ! audio ) {
			this.setState( {
				hasError: true
			} )

			return
		}

		// Setup form data:
		const formData = new FormData()
		formData.append( 'name', sumbitter_name )
		formData.append( 'church_name', church_name )
		formData.append( 'email', email )
		formData.append( 'phone', phone )
		formData.append( 'file', audio, audioFileName )

		// Send:
		this.setState( {
			isProcessing: true
		} )

		axios( {
				url: `${siteData.api_base_url}pocket-studio`,
				timeout: 200000,
				method: 'post',
				responseType: 'json',
				data: formData
			} )
			.then( response => {
				this.showSuccess( audioFileName )
			} )
			.catch( error => {
				let errorMessage = ( error.response && error.response.data ) ? error.response.data.message : ''

				console.error( error.response, 'error' )
				this.showError( errorMessage )
			} )

		// Update account:
		dispatch( updateAccount( {
			church_name: church_name,
			phone: phone
		} ) )
	}

	showSuccess = ( fileName ) => {
		this.setState({
			isProcessing: false,
			isProcessed: true,
			hasError: false,
			files: [],
			uploadedFileNames: [
				...this.state.uploadedFileNames,
				fileName
			]
		})

		setTimeout( () => {
			this.setState({
				isProcessing: false,
				isProcessed: false,
				hasSuccess: true,
			})

			setTimeout( () => {
				this.setState({
					hasSuccess: false
				})
			}, 2000 )
		}, 1000 )
	}

	showError = ( errorMessage ) => {
		this.setState({
			isProcessing: false,
			hasSuccess: false,
			hasError: true,
			errorMessage: errorMessage
		})
	}

	renderUploadedFiles = () => {
		const { uploadedFileNames } = this.state
		let markup

		if ( ! Boolean( uploadedFileNames.length ) ) {
			return
		}

		markup = uploadedFileNames.map( name => {
			return (
				<div className="-uploaded-file" key={ name }>{ name }</div>
			)
		})

		return (
			<div className="form-item -uploaded-files">
				<h3>Uploaded Files</h3>

				{ markup }
			</div>
		)
	}

	render() {
		const { loggedIn, page } = this.props
		const { isProcessing, isProcessed, hasSuccess, hasError, errorMessage, sumbitter_name, church_name, email, phone, fileUploadType, files } = this.state
		const buttonState = isProcessing ? true : null
		let formClass = ''

		if ( isProcessing ) {
			formClass += ' is-processing'
		}

		if ( isProcessed ) {
			formClass += ' is-processed'
		}

		if ( hasSuccess ) {
			formClass += ' is-successful'
		}

		if ( hasError ) {
			formClass += ' has-error'
		}

		if ( ! loggedIn ) {
			return (
				<div className="a">
					<Link to="/signin" className="button">Log in or Sign up</Link>
				</div>
			)
		}

		return (
			<div className="pocket-studio">
				<form className={ formClass } onSubmit={ this.handleSubmit }>
					<Text
						id="sumbitter_name"
						label="Name *"
						value={ sumbitter_name }
						onChange={ this.handleChange }
					/>

					<Text
						id="church_name"
						label="Local Church Name *"
						value={ church_name }
						onChange={ this.handleChange }
					/>

					<Text
						id="email"
						type="email"
						label="Contact Email *"
						value={ email }
						onChange={ this.handleChange }
					/>

					<Text
						id="phone"
						label="Contact Phone Number *"
						value={ phone }
						onChange={ this.handleChange }
					/>

					<RadioButtons
						id="fileUploadType"
						label="Audio submission method"
						value={ fileUploadType }
						options={ [
							{
								name: 'Record',
								id: 'record'
							},
							{
								name: 'Upload',
								id: 'upload'
							}
						] }
						onChange={ this.handleChange }
					/>

					<Record
						id="recordedAudioData"
						label="Record audio"
						onChange={ this.handleChange }
						style={ 'record' != fileUploadType && { display: 'none' } }
					/>

					<File
						id="files"
						label="Audio file"
						buttonLabel="Choose a file..."
						value={ files }
						onChange={ this.handleChange }
						style={ 'upload' != fileUploadType && { display: 'none' } }
					/>

					<div className="form-item">
						<button className="button" type="submit" disabled={ buttonState }>Submit</button>
					</div>

					{ this.renderUploadedFiles() }

					{ hasSuccess &&
						<div className="form-message">
							Thanks!
						</div>
					}

					{ hasError &&
						<div className="form-message">
							{ errorMessage || 'Please complete the form.' }
						</div>
					}
				</form>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.site.accountData,
		loggedIn: state.site.loggedIn,
		page: state.page.selected,
		userName: state.schedule.userName,
		userEmail: state.schedule.userEmail,
		userPhone: state.schedule.userPhone,
		userChurchName: state.schedule.userChurchName
	}
}

export default connect( mapStateToProps )( PocketStudio )
